import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Card, CardBody } from "reactstrap";

const PrivacyPolicy = () => {
  //meta title
  document.title = "Privacy Policy | BizServe";

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-5">
        <Container>
          <Row className="justify-content-center">
            <Col lg="10">
              <Card>
                <CardBody className="p-4">
                  <div className="text-center mb-4">
                    <h2 className="mb-3">Privacy Policy</h2>
                    <p className="text-muted">Last Updated: {new Date().toLocaleDateString()}</p>
                  </div>

                  <div className="mt-4">
                    <h4 className="mb-3">1. Introduction</h4>
                    <p className="text-muted">
                      Welcome to BizServe. We are committed to protecting your personal information and your right to privacy. 
                      This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit 
                      our website and use our services.
                    </p>
                  </div>

                  <div className="mt-4">
                    <h4 className="mb-3">2. Information We Collect</h4>
                    <p className="text-muted mb-2">We may collect information about you in a variety of ways. The information we may collect includes:</p>
                    <ul className="text-muted">
                      <li><strong>Personal Data:</strong> Name, email address, phone number, mailing address, and other similar contact data.</li>
                      <li><strong>Payment Data:</strong> Credit card information, billing address, and other payment-related information.</li>
                      <li><strong>Company Information:</strong> Company name, business address, tax identification numbers, and other business-related data.</li>
                      <li><strong>Usage Data:</strong> Information about how you access and use our services, including IP address, browser type, and device information.</li>
                    </ul>
                  </div>

                  <div className="mt-4">
                    <h4 className="mb-3">3. How We Use Your Information</h4>
                    <p className="text-muted mb-2">We use the information we collect to:</p>
                    <ul className="text-muted">
                      <li>Provide, maintain, and improve our services</li>
                      <li>Process transactions and send related information</li>
                      <li>Send administrative information, updates, and security alerts</li>
                      <li>Respond to your comments, questions, and requests</li>
                      <li>Monitor and analyze trends, usage, and activities</li>
                      <li>Detect, prevent, and address technical issues and fraudulent activities</li>
                    </ul>
                  </div>

                  <div className="mt-4">
                    <h4 className="mb-3">4. Information Sharing and Disclosure</h4>
                    <p className="text-muted">
                      We do not sell, trade, or rent your personal information to third parties. We may share your information 
                      only in the following circumstances:
                    </p>
                    <ul className="text-muted">
                      <li>With service providers who perform services on our behalf</li>
                      <li>To comply with legal obligations or respond to lawful requests</li>
                      <li>To protect our rights, privacy, safety, or property</li>
                      <li>In connection with a business transfer or merger</li>
                    </ul>
                  </div>

                  <div className="mt-4">
                    <h4 className="mb-3">5. Data Security</h4>
                    <p className="text-muted">
                      We implement appropriate technical and organizational security measures to protect your personal information. 
                      However, no method of transmission over the Internet or electronic storage is 100% secure, and we cannot 
                      guarantee absolute security.
                    </p>
                  </div>

                  <div className="mt-4">
                    <h4 className="mb-3">6. Your Rights</h4>
                    <p className="text-muted mb-2">You have the right to:</p>
                    <ul className="text-muted">
                      <li>Access and receive a copy of your personal data</li>
                      <li>Rectify inaccurate or incomplete personal data</li>
                      <li>Request deletion of your personal data</li>
                      <li>Object to processing of your personal data</li>
                      <li>Request restriction of processing your personal data</li>
                      <li>Data portability</li>
                    </ul>
                  </div>

                  <div className="mt-4">
                    <h4 className="mb-3">7. Cookies and Tracking Technologies</h4>
                    <p className="text-muted">
                      We use cookies and similar tracking technologies to track activity on our website and hold certain information. 
                      You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent.
                    </p>
                  </div>

                  <div className="mt-4">
                    <h4 className="mb-3">8. Children's Privacy</h4>
                    <p className="text-muted">
                      Our services are not intended for individuals under the age of 18. We do not knowingly collect personal 
                      information from children. If you become aware that a child has provided us with personal information, 
                      please contact us immediately.
                    </p>
                  </div>

                  <div className="mt-4">
                    <h4 className="mb-3">9. Changes to This Privacy Policy</h4>
                    <p className="text-muted">
                      We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new 
                      Privacy Policy on this page and updating the "Last Updated" date.
                    </p>
                  </div>

                  <div className="mt-4">
                    <h4 className="mb-3">10. Contact Us</h4>
                    <p className="text-muted">
                      If you have any questions about this Privacy Policy, please contact us at:
                    </p>
                    <p className="text-muted">
                      <strong>Email:</strong> privacy@bizserve.com<br />
                      <strong>Address:</strong> BizServe LLC, 123 Business Street, Suite 100, City, State, ZIP Code
                    </p>
                  </div>

                  <div className="mt-5 text-center">
                    <Link
                      className="btn btn-primary waves-effect waves-light"
                      to="/register"
                    >
                      Back to Registration
                    </Link>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default PrivacyPolicy;
